const globalReducer = (state, action) => {
  switch (action.type) {
    case "FETCH_START":
      return {
        ...state,
        isLoading: true,
        error: null,
      };
    case "FETCH_SUCCESS":
      return {
        ...state,
        isLoading: false,
        error: null,
      };
    case "FETCH_ERROR":
      return {
        ...state,
        isLoading: false,
        error: action.payload,
      };
    case "ALL_RELEASES": 
      return {
        ...state,
        allReleases: action.payload,
      };
      case "LATEST_RELEASE": 
      return {
        ...state,
        latestRelease: action.payload,
      };
      case "RANGE_RELEASES": 
      return {
        ...state,
        rangeReleases: action.payload,
      };
      case "SELECTED_TIME_RANGE": 
      return {
        ...state,
        selectedTimeRange: action.payload,
      };
    default:
      return state;

    
  }
};

// to use :
/* import React, { useContext } from 'react';
import { JobContext } from '../context/JobContext';

  const { state, dispatch } = useContext(JobContext);
  const { incompleteJobs } = state;

  const addJob = () => {
    const newJob = { jobId: '65631', jobStatus: 'PENDING' };
    dispatch({ type: 'ADD_JOB', payload: newJob });
  };

  const updateJobStatus = (jobId, status) => {
    dispatch({ type: 'UPDATE_JOB_STATUS', payload: { jobId, jobStatus: status } });
  };

  const removeJob = (jobId) => {
    dispatch({ type: 'REMOVE_JOB', payload: jobId });
  };*/

export default globalReducer;
